class Constants{
    static EOWP_DOMAIN_HOST_PROD = "eowp-shop.alc.co.jp";
    static EOWP_DOMAIN_HOST_STAGING = "st.eowp-shop.alc.co.jp";
    static EOWP_DOMAIN_HOST_P2_STAGING = "p2-st.eowp-shop.alc.co.jp";

    static EOWP_SHOP_SUBSCRIPTION_TRIAL_14_DAYS = '2024-02-01';
}

export default Constants;
